<template>
    <div class="write-off-container">
        <!-- 商品信息区域 -->
        <div class="product-section">
            <div class="product-item">
                <div class="product-image">
                    <img src="/src/assets/img/writeoff/write-off-1.png" alt="商品图片" />
                </div>
                <div class="product-info">
                    <div class="product-name">商品名称</div>
                    <div class="product-spec">规格：100ml</div>
                    <div class="product-price">
                        <img class="points-icon" :src="pointsIcon" alt="积分图标" />
                        <span class="price-text">1000+¥9.90</span>
                    </div>
                </div>
                <div class="product-quantity">x1</div>
            </div>
            <div class="product-item">
                <div class="product-image">
                    <img src="/src/assets/img/writeoff/write-off-1.png" alt="商品图片" />
                </div>
                <div class="product-info">
                    <div class="product-name">商品名称</div>
                    <div class="product-spec">规格：100ml</div>
                    <div class="product-price">
                        <img class="points-icon" :src="pointsIcon" alt="积分图标" />
                        <span class="price-text">1000+¥9.90</span>
                    </div>
                </div>
                <div class="product-quantity">x1</div>
            </div>
        </div>
        <div class="product-label">
            <!-- 线下付款提示 -->
            <div class="payment-tip">
                <div class="tip-title">
                    <div class="title-content-list">需线下付款</div>
                    <div class="tip-note">注：核销前需向客户收款</div>
                </div>
                <div class="tip-amount">28元</div>
            </div>
            <!-- 总计金额 -->
            <div class="total-section">
                <div class="total-label">累计</div>
                <div class="total-amount">
                    <img class="points-icon" :src="pointsIcon" alt="积分图标" />
                    <span class="price-text">2000+28元</span>
                </div>
            </div>
        </div>

    </div>
    <!-- 底部按钮区域 -->
    <div class="border-bottom">
        <div class="border-cancel" @click="cancelWriteOff">取消</div>
        <div class="border-go" @click="confirmWriteOff">确认核销</div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router';
import { showToast } from 'vant'
import pointsIcon from '@/assets/img/writeoff/scoe-ico.png'

const router = useRouter()
const route = useRoute()
const order_uuid = route.query.order_uuid || '';
// 取消核销
const cancelWriteOff = () => {
    router.back()
}

// 确认核销
const confirmWriteOff = () => {
    // 这里应该调用核销API
    showToast({
        message: '核销成功',
        type: 'success'
    })
    // 核销成功后返回上一页
    setTimeout(() => {
        router.back()
    }, 1500)
}
</script>

<style lang="less" scoped>
.write-off-container {
    min-height: 100vh;
    background-color: #f5f5f5;
    margin-bottom: 70px;
    padding: 0 17px;
}

/* 商品信息区域 */
.product-section {
    background-color: #ffffff;
    padding: 14px;
    margin-top: 10px;
    border-radius: 8px;
    overflow: hidden;

    .product-item {
        display: flex;
        align-items: flex-start;

        &:not(:last-child) {
            padding-bottom: 12px;
            margin-bottom: 12px;
            border-bottom: 1px solid #E5E5E5;
        }
    }

    .product-image {
        width: 86px;
        height: 86px;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 10px;
    }

    .product-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .product-info {
        flex: 1;

        .product-name {
            font-size: 15px;
            font-weight: 500;
            color: #333333;
            margin-bottom: 4px;
        }

        .product-spec {
            font-size: 13px;
            color: #666666;
            margin-bottom: 12px;
        }

        .product-price {
            font-size: 15px;
            color: #FF7123;
            font-weight: 500;
            display: flex;
            align-items: center;

            .points-icon {
                margin-right: 2px;
                width: 23px;
                height: 23px;
            }

            .price-text {
                line-height: 23px;
            }
        }
    }

    .product-quantity {
        font-size: 15px;
        color: #666666;
        align-self: flex-start;
        margin-top: 40px;
    }
}

.product-label {
    margin-top: 12px;
    border-radius: 8px;
    background-color: #ffffff;
    padding: 14px;
    margin-top: 10px;

    /* 线下付款提示 */
    .payment-tip {
        background-color: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #E5E5E5;
        padding-bottom: 12px;

        .tip-title {
            font-size: 15px;
            color: #333333;
            font-weight: 500;
        }

        .tip-note {
            font-size: 13px;
            color: #999999;
            margin-top: 2px;
        }

        .tip-amount {
            font-size: 15px;
            color: #FF7123;
            font-weight: 600;
        }
    }

    /* 总计金额 */
    .total-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 12px;
        .total-label {
            font-size: 15px;
            color: #333333;
            font-weight: 500;
        }

        .total-amount {
            font-size: 15px;
            color: #FF7123;
            font-weight: 600;
            display: flex;
            align-items: center;

            .points-icon {
                margin-right: 2px;
                width: 23px;
                height: 23px;
            }

            .price-text {
                line-height: 23px;
            }
        }
    }
}

/* 底部按钮区域 */
.border-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    padding: 10px 17px 20px 17px;
    border-bottom: 1px solid #E5E5E5;
    background-color: #FFFFFF;

    .border-center {
        display: flex;
        align-items: center;

        .full-select {
            font-size: 15px;
            color: #333;
            font-family: 'PingFang SC-Medium';
            font-weight: 500;
            margin-left: 4px;
        }
    }

    .border-cancel {
        width: 105px;
        height: 36px;
        border-radius: 2px;
        border: 1px solid #eee;
        font-size: 15px;
        color: #666;
        font-family: 'PingFang SC-Medium';
        font-weight: 400;
        line-height: 36px;
        text-align: center;
        margin-right: 17px;
    }

    .border-go {
        font-size: 15px;
        color: #fff;
        width: 105px;
        height: 36px;
        border-radius: 2px;
        border: 1px solid #DCBB89;
        font-size: 15px;
        font-family: 'PingFang SC-Medium';
        font-weight: 400;
        line-height: 36px;
        text-align: center;
        background-color: #DCBB89;
    }
}
</style>
